<template>
    <card :title="$t('active_subscriptions')">
        <div class="btn-group">
            <router-link :to="{ name: 'user.subscription.create'}"
                         :formTitle="$t('create_subscription')"
                         class="btn btn-primary"
                         active-class="active">
                {{ $t('create_new_subscription') }}
            </router-link>
        </div>

        <div class="list-group" v-for="item in subscriptions">
            <router-link :to="{ name: 'user.subscription.edit', params: { id: item.id }}"
                         :formTitle="$t('edit_subscription')"
                         class="nav-link list-group-item"
                         active-class="active">
                <div class="col-md-12">
                    <h4 class="list-group-item-heading">{{ item.title }}</h4>
                    <p class="list-group-item-text">{{ item.description }}</p>
                </div>
            </router-link>
        </div>
        <p class="text-center" v-if="subscriptions && subscriptions.length === 0">Here is going to be placed the list of subscriptions!!!</p>
    </card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "",

        components: {
            //
        },

        data: () => ({}),

        computed: {
            ...mapGetters({
                getSubscriptions: 'getSubscriptions'
            }),

            subscriptions() {
                return this.getSubscriptions;
            }
        },

        created() {
            this.$store.dispatch('getSubscriptions');
        },

        methods: {}
    }
</script>

<style scoped>
    .btn.btn-primary {
        margin-bottom: 15px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/subscriptions/list.vue